import Styles from "components/glampartners/HorizontalResults.module.scss";
import React from "react";
import { Utils } from "utils/Utils";

const renderPeriod = (period, unitName) => {
  if (Object.keys(period).length === 0 && period.constructor === Object) {
    let columns = [];
    for (let i = 0; i < 5; i++) {
      if (i === 0) {
        if(unitName === "Publi")  columns.push(<td >Nenhuma Participação</td>);
        else columns.push(<td >Nenhuma venda</td>);
      } else {
        columns.push(<td ><div className={Styles["value"]}><span>{Utils.toCurrency(0)}</span><span></span></div> </td>);
      }
    }
    return columns;

  } else {
    return Object.keys(period).map((periodName, pKey) => {

      if (period[periodName] === null) {
        return (
          <td  key={pKey}>
            <div className={Styles["value"]} >
              <span>{Utils.toCurrency(0)}</span>
              <span></span>
            </div>
          </td>
        );
      }

      return (
        <td key={pKey} >
          <div className={Styles["value"]}>
            <span>{Utils.toCurrency(period[periodName].payment)}</span>
            <span></span>
          </div>
        </td>
      );
    });
  }

};

const renderTable = (types, unitName) => {
  if (Object.keys(types).length === 0 && types.constructor === Object) {
    return (
      <tr className={Styles["payment-row"]}>
        {renderPeriod(types, unitName)}
      </tr>
    );
  }

  return Object.keys(types).map((typeName, tKey) => {
    return (
      <tr className={Styles["payment-row"]} key={tKey}>
        <td ><p>{typeName}</p></td>
        {renderPeriod(types[typeName])}
      </tr>
    );
  });
};

const renderTableGroup = (data) => {
  return Object.keys(data).map((unitName, uKey) => {
    return (
      <div className={Styles["unit-results"]} key={uKey}>
        <h3 className={"display-3"}>{unitName.replace('Assinatura', 'Assinaturas').replace('Publi', 'Publis')}</h3>

        <table className={"table table-bordered"}>
          <tbody>{renderTable(data[unitName], unitName)}</tbody>
        </table>
      </div>
    );
  });
};

const renderMonths = (data) => {
  //let unit = data[Object.keys(data)[0]];
  //let type = unit[Object.keys(unit)[0]];
  //let date = Object.keys(type);
  const date = Utils.getPeriodRange(4, true);
  return (
    <table className={Styles["horizontal-results"]}>
      <thead>
        <tr>
          <th >&nbsp;</th>
          {(() => {
            return date.map((item, key) => {
              let xp = item.split("/");
              let dt = new Date(xp[1], parseInt(xp[0], 10) - 1, 1);

              return (
                <th  key={key}>
                  <h3 className={"display-3"}>{dt.toLocaleString("pt-BR", { month: "long" })}</h3>
                </th>
              );
            });
          })()}
        </tr>
      </thead>
    </table>
  );
};

const renderTotals = (totals) => {
  let date = Object.keys(totals);

  return (
    <table className={Styles["horizontal-results"]}>
      <tfoot>
        <tr className={Styles["total-row"]}>
          <th >Total:</th>
          {(() => {
            return date.map((item, key) => {
              return (
                <td   key={key}>
                  <div className={Styles["value"]}>
                    <span><strong>{Utils.toCurrency(totals[item])}</strong></span>
                    <span></span>
                  </div>
                </td>
              );
            });
          })()}
        </tr>
      </tfoot>
    </table>
  );
};

export const HorizontalResults = ({ data }) => {
  const { table, totals } = data;

  return (
    <div className={Styles["horizontal-results-container"]}>
      {renderMonths(table)}
      <div className={Styles["horizontal-results"]}>
        <div className={Styles["hr-content"]}>
          {renderTableGroup(table)}
        </div>
      </div>
      {renderTotals(totals)}
    </div>
  );
};
